window.app.directive("modelChange", [
  "$rootScope",
  "$parse",
  function($rootScope, $parse) {
    return {
      restrict: "A",
      scope: false,
      require: "^ngModel",
      link: function(scope, element, attrs, ngModelCtrl) {
        var getModelChangeArgs = $parse(attrs.modelChangeArgs);
        var commitViewValue = ngModelCtrl.$commitViewValue;
        ngModelCtrl.$commitViewValue = function() {
          commitViewValue.call(ngModelCtrl);
          var args = getModelChangeArgs(scope);
          args.unshift(attrs.modelChange);
          scope.$emit.apply(scope, args);
        };
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/directives/model-change.js